module.exports = __webpack_public_path__ + "tabletSlideAlt.webp?428faeadcd74820a4e2f9ed8d30b58c7";